import { useMutation } from 'react-query';
import { useAPI } from './useAPI';
import { useChuckClientContext } from './useChuckClientContext';
export const useEventCreation = () => {
    const { post } = useAPI();
    const { client } = useChuckClientContext();
    return useMutation((data) => {
        return post({ url: '/events', data }).then((res) => res.data);
    }, {
        onError: (err) => {
            client.captureException(err);
        }
    });
};
//# sourceMappingURL=useEventCreation.js.map